import React, { useRef } from 'react';
import { Button, Col } from 'antd';
import { UploadOutlined, ExportOutlined } from '@ant-design/icons';
import { Droppable } from 'react-beautiful-dnd';
import classNames from 'classnames';
import dropImg from '../assets/drop-here-certs.png';
import Certification from './Certification';
import {importJsonFile} from "../../Utils";

const SelectedCertifications = ({ columns, certifications, importData, removeCertification, openAddModal }) => {
  const fileInputRef = useRef();

  const exportJsonFile = () => {
    const itemsToExport = [];
    ['selected'].forEach((columnId) => {
      columns[columnId].certificationIds.forEach((certId) => {
        itemsToExport.push({
          ...certifications[certId],
          position: columnId,
        });
      });
    });
    const element = document.createElement('a');
    const file = new Blob([JSON.stringify({ certifications: itemsToExport })], { type: 'application/json' });
    element.href = URL.createObjectURL(file);
    element.download = 'my-certifications.json';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const printDroppable = (columnId, emptyPlaceholder) => (
    <Droppable droppableId={columnId}>
      {(provided, snapshot) => {
        const listClass = classNames('list-selected', {
          'drag-over': snapshot.isDraggingOver,
        });
        return (
          <div ref={provided.innerRef} {...provided.droppableProps} className={listClass}>
            {columns[columnId].certificationIds.map((certId, idx) => (
              <Certification
                key={certifications[certId].id}
                certification={certifications[certId]}
                index={idx}
                removeCertification={removeCertification}
                openAddModal={openAddModal}
                columnId={columnId}
              />
            ))}
            {provided.placeholder}
            {columns[columnId].certificationIds.length === 0 && emptyPlaceholder}
          </div>
        );
      }}
    </Droppable>
  );

  return (
    <Col xs={24} lg={12} xl={8} className="base-selected">
      <h3 className="section-title">Your Certifications</h3>
      <div className="base-selected-content">
        <div className="base-selected-content-scroll">
          <div className="buttons-container">
            <input type="file" accept="application/json" ref={fileInputRef} className="file-input-hidden" onChange={(e) => importJsonFile(e,importData)} />
            <Button icon={<UploadOutlined />} onClick={() => fileInputRef.current.click()} className="button import">
              Import
            </Button>
            <Button icon={<ExportOutlined />} onClick={exportJsonFile} className="button export">
              Export
            </Button>
          </div>
          {printDroppable('selected', <img src={dropImg} className="drop-img" alt="Drop here" />)}
        </div>
      </div>
    </Col>
  );
};

export default SelectedCertifications;
